import React from 'react';
import { graphql } from 'gatsby';
import { Cards as CardsComponent } from '../../../cards/Cards';

export const Cards = ({ data, ...rest }) => (
  <CardsComponent {...data} {...rest} />
);

export const CardsQuery = graphql`
  fragment Cards on UMBRACO_CardsComponentType {
    display
    cardBackground
    components {
      __typename
      ... on UMBRACO_CustomContentComponentType {
        tag
        heading
        description
        tickListItems
        link {
          ...Link
        }
        image {
          image {
            ...CardImage
          }
        }
      }
      ... on UMBRACO_PagePickerComponentType {
        page {
          linkContent {
            ... on UMBRACO_PageType {
              properties {
                feed {
                  shortTitle
                  shortDescription
                  featuredImage {
                    image {
                      ...CardImage
                    }
                  }
                }
              }
            }
          }
          linkName
          url
        }
      }
    }
  }
`;
